export const dsColorBrandDahlia = "#ec0041";
export const dsColorBrandDahliaFade = "#fbccd9";
export const dsColorBrandDahliaDark = "#bd0034";
export const dsColorBrandDahliaDarker = "#a5002e";
export const dsColorBrandFog = "#d8dde6";
export const dsColorBrandFogFade = "#f3f5f8";
export const dsColorBrandFogDark = "#a0acc2";
export const dsColorBrandFogDarker = "#8797b2";
export const dsColorBrandMidnight = "#475470";
export const dsColorBrandMidnightFade = "#dadde2";
export const dsColorBrandMidnightDark = "#39435a";
export const dsColorBrandMidnightDarker = "#323b4e";
export const dsColorBrandAbyss = "#2f3542";
export const dsColorBrandAbyssFade = "#d5d7d9";
export const dsColorBrandAbyssDark = "#262a35";
export const dsColorBrandAbyssDarker = "#21252e";
